export default {
  "productCenter": {
    "learnMore": "了解详情",
    "embedding": {
      "name": "嵌入式芯片",
      "description": "采用先进工艺，功耗低、运行稳定。具备强大的处理能力，可满足多种复杂应用需求。为客户提供高效、可靠的解决方案，助力行业发展。",
      "spec": "产品规格",
      "interface": "接口",
      "size": "尺寸",
      "msrs": "最大顺序读取速度",
      "msws": "最大顺序写入速度",
      "cap": "容量",
      "cert": "认证",
      "vop": "工作电压",
      "apply": "应用方向",
      "emmc": {
        "name": "EMMC",
        "description": "遵循JEDEC eMMC5.0/5.1标准, 将MMC接口、快闪存储器设备及主控制器封装于一个小型BGA上，显著减少主机处理器上的存储管理负载。支持8GB~256GB容量段。具有快速、可升级的性能，同时其接口电压可以是1.8v或者是3.3v。超强兼容性，快速处理与主控制器及闪存的技术兼容问题。",
        "interface": "eMMC 5.0 & eMMC 5.1",
        "size": "11.5mm×13mm×1.00mm",
        "msrs": "160-270MB/s",
        "msws": "70-210MB/s",
        "cap": "8GB~128GB",
        "cert": "CE、3C、FCC、ROHs",
        "vop": "VCC=2.7~3.6V，VCCQ=1.7~1.95V/2.7~3.6V",
        "apply": "车载、平板、工控机、无人机"
      },
      "ufs": {
        "name": "UFS",
        "description": "遵循JEDEC UFS3.1国际标准，兼容UFS2.2/2.1，支持128GB~1TB容量，将UFS接口、快闪存储器及主控制器，都集成在一个小型的BGA 封装内。UFS的串行数据传输技术具备高速度、高可靠性，抗干扰能力强，并能显著减少主机处理器上的存储管理负载。",
        "interface": "MIPI M-PHY",
        "size": "11mm×13mm×1.00mm",
        "msrs": "1200MB/s",
        "msws": "70-210MB/s",
        "cap": "64GB~128GB",
        "cert": "CE、3C、FCC、ROHs",
        "vop": "VCC=1.8~3.3V，VCCQ=1.7~1.95V/2.7~3.6V",
        "apply": "高端智能手机、服务器"
      },
      "sip-ic": {
        "name": "SIP IC",
        "description": "遵循JEDEC UFS3.1国际标准，兼容UFS2.2/2.1，支持128GB~1TB容量，将UFS接口、快闪存储器及主控制器，都集成在一个小型的BGA 封装内。UFS的串行数据传输技术具备高速度、高可靠性，抗干扰能力强，并能显著减少主机处理器上的存储管理负载。",
        "interface": "MIPI M-PHY",
        "size": "11mm×13mm×1.00mm",
        "msrs": "1200MB/s",
        "msws": "70-210MB/s",
        "cap": "64GB~128GB",
        "cert": "CE、3C、FCC、ROHs",
        "vop": "VCC=1.8~3.3V，VCCQ=1.7~1.95V/2.7~3.6V",
        "apply": "高端智能手机、服务器"
      }
    },
    "rdimm": {
      "name": "储存模组",
      "description": "采用先进工艺，功耗低、运行稳定。具备强大的处理能力，可满足多种复杂应用需求。为客户提供高效、可靠的解决方案，助力行业发展。",
      "spec": "产品规格",
      "interface": "接口",
      "size": "尺寸",
      "msrs": "最大顺序读取速度",
      "msws": "最大顺序写入速度",
      "cap": "容量",
      "cert": "认证",
      "vop": "工作电压",
      "opTemp": "工作温度",
      "apply": "应用方向",
      "ssd-25": {
        "name": "2.5‘ SSD固态硬盘",
        "description": "遵循JEDEC UFS3.1国际标准，兼容UFS2.2/2.1，支持128GB~1TB容量，将UFS接口、快闪存储器及主控制器，都集成在一个小型的BGA 封装内。UFS的串行数据传输技术具备高速度、高可靠性，抗干扰能力强，并能显著减少主机处理器上的存储管理负载。",
        "interface": "SATA3.0",
        "size": "2.5寸",
        "msrs": "500MB/s",
        "msws": "450~480MB/s",
        "cap": "128GB~4TB",
        "cert": "CE、3C、FCC、ROHs",
        "vop": "VCC=3.3V，VCCQ=1.8V",
        "opTemp": "Consumer grade：0℃~70℃、-20℃~85℃",
        "apply": "台式电脑、服务器、工控机"
      },
      "ssd-m2": {
        "name": "M.2 SSD固态硬盘",
        "description": "遵循JEDEC UFS3.1国际标准，兼容UFS2.2/2.1，支持128GB~1TB容量，将UFS接口、快闪存储器及主控制器，都集成在一个小型的BGA 封装内。UFS的串行数据传输技术具备高速度、高可靠性，抗干扰能力强，并能显著减少主机处理器上的存储管理负载。",
        "interface": "M.2 2280、2260、2242 SATA M.2 2280、2260、2242 PCIe",
        "size": "22mm×80mm、22mm×60mm、22mm×42mm",
        "msrs": "500MB/s 1200~2700MB/s",
        "msws": "420MB/s 950~1600MB/s",
        "cap": "128GB~2TB",
        "cert": "CE、3C、FCC、ROHs",
        "vop": "VCC=3.3V，VCCQ=1.8V",
        "opTemp": "Consumer grade：0℃~70℃、-20℃~85℃",
        "apply": "笔记本电脑、平板电脑"
      },
      "ssd-sc": {
        "name": "Special Conn SSD",
        "description": "支持128GB~16TB容量，高可靠性能，读写速度快，保证数据稳定高效传输，为工业、汽车和商业存储市场提供了更多的可靠性。",
        "interface": "SATA转SAS、U.2、U.3、U.6等",
        "size": "客供尺寸要求",
        "msrs": "320~1000MB/s",
        "msws": "250~800MB/s",
        "cap": "128GB~16TB",
        "cert": "CE、3C、FCC、ROHs",
        "vop": "VCC=3.3V，VCCQ=1.8V",
        "opTemp": "Consumer grade：0℃~70℃、-20℃~85℃、-40℃~105℃",
        "apply": "车规级、加固笔记本电脑、工控机"
      },
      "ssd-ent": {
        "name": "企业级数据盘",
        "description": "512GB~16TB容量，读写速度快，高效传输，为数据中心、超算中心、AI算力平台提供更多的可靠产品。",
        "interface": "U.2 NVMe",
        "size": "2.5寸",
        "msrs": "500~3000MB/s",
        "msws": "1200~2700MB/s",
        "cap": "512GB~16TB",
        "cert": "CE、3C、FCC、ROHs",
        "vop": "VCC=3.3V，VCCQ=1.8V",
        "opTemp": "Consumer grade：0℃~70℃",
        "apply": "数据中心、智算中心、企业级专网用户"
      },
      "ssd-server": {
        "name": "服务器系统盘",
        "description": "稳定读写，耐宽温，可做三防处理。",
        "interface": "SATA转SAS、U.2、U.3、U.6等",
        "size": "客供尺寸要求",
        "msrs": "320~1000MB/s",
        "msws": "250~800MB/s",
        "cap": "128GB~16TB",
        "cert": "CE、3C、FCC、ROHs",
        "vop": "VCC=3.3V~24V，VCCQ=1.8V~12V",
        "opTemp": "Consumer grade：0℃~70℃、-20℃~85℃、-40℃~105℃",
        "apply": "车规级、加固笔记本电脑、工控机"
      }
    },
    "sd": {
      "name": "储存设备",
      "description": "具备大容量空间，可轻松存储大量数据。读写速度快，响应迅速。设计坚固耐用，能适应各种复杂环境。提供安全、高效的存储体验，是数据存储的理想之选。",
      "spec": "产品规格",
      "interface": "接口",
      "size": "尺寸",
      "msrs": "最大顺序读取速度",
      "msws": "最大顺序写入速度",
      "cap": "容量",
      "cert": "认证",
      "vop": "工作电压",
      "opTemp": "工作温度",
      "apply": "应用方向",
      "dsd": {
        "name": "分布式存储设备",
        "description": "分布式存储设备，高效可靠。将数据分散存储在多台独立设备上，提高存储容量和可靠性。具备快速读写、灵活扩展的优势。适用于大规模数据存储场景，为企业和个人提供稳定、安全的存储解决方案，助力数据管理更便捷。",
        "interface": "此处是内容",
        "size": "U2标准机柜、U3标准机柜、SAS、SATA、NVMe Conn",
        "msrs": "此处是内容",
        "msws": "此处是内容",
        "cap": "2~8盘位、10TB~100TB",
        "cert": "CE、3C、FCC、ROHs",
        "vop": "此处是内容",
        "opTemp": "此处是内容",
        "apply": "单位数据保护、小型数据中心"
      },
      "csd": {
        "name": "集中式存储设备",
        "description": "集中式存储设备，性能稳定。整合存储资源于一处，方便管理与维护。提供高容量存储和快速数据访问。适用于企业级应用，确保数据安全集中管控。以强大的性能和可靠性，满足不同场景下的数据存储需求。",
        "interface": "此处是内容",
        "size": "U3标准机柜、U6标准机柜、SAS、SATA、NVMe Conn",
        "msrs": "此处是内容",
        "msws": "此处是内容",
        "cap": "200PB~800PB",
        "cert": "CE、3C、FCC、ROHs",
        "vop": "此处是内容",
        "opTemp": "此处是内容",
        "apply": "大型数据中心、智算中心、云计算中心"
      },
      "csc-rack": {
        "name": "存算阵列中心机柜",
        "description": "存算阵列中心机柜，功能强大。集成存储与计算功能，高效处理海量数据。结构坚固，散热良好。为数据中心提供稳定可靠的运行环境。可灵活扩展，满足不断增长的业务需求，是现代数据处理的关键设备。",
        "interface": "此处是内容",
        "size": "U3标准机柜、U6标准机柜、SAS、SATA、NVMe Conn",
        "msrs": "此处是内容",
        "msws": "此处是内容",
        "cap": "200PB~800PB",
        "cert": "CE、3C、FCC、ROHs",
        "vop": "此处是内容",
        "opTemp": "此处是内容",
        "apply": "大型数据中心、智算中心、云计算中心"
      },
      "ida": {
        "name": "数据系统集成的阵列",
        "description": "数据系统集成阵列，高效整合。将多种设备和技术融合，实现数据的统一管理和存储。具备高可靠性和可扩展性。提升数据处理效率，为企业提供一站式数据解决方案，助力业务发展，是现代数据管理的有力工具。",
        "interface": "此处是内容",
        "size": "U3标准机柜、U6标准机柜、SAS、SATA、NVMe Conn",
        "msrs": "此处是内容",
        "msws": "此处是内容",
        "cap": "100EB~900EB",
        "cert": "CE、3C、FCC、ROHs",
        "vop": "此处是内容",
        "opTemp": "此处是内容",
        "apply": "大型数据中心、智算中心、云计算中心、数据集群项目"
      }
    }
  },
  "message": {
    "hello": "我们的产品",
    "language": "为客户创造更大价值",
    "cd": "菜单",
    "ck": "查看更多",
    "plan": "我们的解决方案",
    "perfect": "提供完善的解决方案",
    "lj": "了解详情",
    "ab": "关于我们",
    "zl": "致力于成为专业的半导体企业",
    "zx": "服务咨询",
    "my": "没有找到合适的商品，可以联系我们寻求帮助，会有工作人员与您联系。",
    "con": "联系我们",
    "wsh": "为什么选择新甚科技",
    "ljsh": "了解新甚科技",
    "ks": "快速选择您想要的产品",
    "cp": "查看新甚科技的产品",
    "gb": "关闭",
    "cpgl": "产品概览",
    "zxzx": "资讯中心",
    "fzxzx": "了解新甚科技最新动态和行业资讯",
    "pzyl": "品质引领，创新驱动",
    "wmdcp": "我们的产品融合创新科技与精湛工艺，性能卓越，品质可靠。满足多元需求，为你带来全新的使用体验，开启精彩生活。"
  },
  "About": {
    "ab1": "浙江新甚科技有限公司-半导体存储系列产品生产制造配套的技术企业",
    "ab2": "主要产品应用于消费级SSD、高性能ESSD：系统级固态盘、企业级数据盘；存储设备类：NAS、SAN、存算一体的数据机柜等。",
    "ab3": "1、具备NAND FLASH 、DDR系列、LPDDR系列及嵌入式存储芯片（eMMC 、UFS 、uMCP 、eSSD）的封装及测试量产能力，并可实现多层次多种类的芯片叠加的SiP封装、高密度低功耗芯片的封装（HBM）等。",
    "ab4": "2、已获ISO9001 、BSCI 、CE、3C、FCC、RoHs等多项认证半导体专委会、科创联盟副理事长单位。"
  },
  "Solution": {
    "so0": "数据中心",
    "so1": "为数据中心提供高性能芯片，用于计算、存储与网络传输，优化能耗与散热，助力数据中心高效运作。",
    "so2": "客户端PC",
    "so3": "在客户端 PC 中提供核心处理器、内存等关键组件，提升性能与能效，满足用户多样化的计算和娱乐需求。",
    "so4": "汽车",
    "so5": "为汽车提供动力控制、自动驾驶等关键芯片，提升安全性与智能化水平，推动汽车产业创新发展。",
    "so6": "移动设备",
    "so7": "助力移动设备实现高性能处理器、优质通信模块及高效电源管理，提升移动设备的功能与续航能力。",
    "so8": "人工智能/GC",
    "so9": "为人工智能提供强大算力芯片，加速数据处理与模型训练，助力人工智能实现更智能的应用与发展。",
    "so10": "智慧家居",
    "so11": "为消费者带来高性能电子设备，如智能手机、智能家电等，提升生活品质与便捷性，满足多元需求。",
    "so12": "网络基础设施",
    "so13": "助力网络基础设施实现高速数据传输与处理，提升网络性能与稳定性，支撑数字化时代的通信需求。",
    "so14": "工业互联网",
    "so15": "为工业互联网提供可靠芯片，实现设备互联与智能控制，提高工业生产效率与质量，推动产业升级。"
  },
  "header": {
    "menu0": "产品中心",
    "menu1": "市场与行业",
    "menu2": "销售与支持",
    "menu3": "关于我们",
    "spe0": "2.5‘ SSD固态硬盘",
    "spe1": "企业级数据盘",
    "spe2": "服务器系统盘",
    "spe3": "集中式存储设备",
    "spe4": "存算阵列中心机柜",
    "spe5": "数据系统集成的阵列",
    "spe6": "品质引领，创新驱动",
    "menu4": "市场与行业概览",
    "spe7": "携手市场伙伴，共创行业辉煌",
    "menu5": "销售与支持概况",
    "spe8": "销售点亮前路，支持托举梦想",
    "spe9": "诚信为本，专业铸就卓越",
    "spe10": "公司介绍",
    "spe11": "我的工厂",
    "spe12": "联系我们",
    "spe13": "新闻资讯",
    "spe14": "及时发布公司动态、行业热点，让你第一时间了解公司的最新进展。"
  },
  "zxzx": {
    "zx1": "公司动态"
  },
  "footer": {
    "foo1": "公司地址",
    "foo2": "浙江省湖州市吴兴区织里镇鹏飞路1888号4号楼",
    "foo3": "联系电话",
    "foo4": "商务合作"
  },
  "route": {
    "rou0": "主页",
    "rou1": "产品概览"
  },
  "EMMC": {
    "name": "嵌入式芯片",
    "js": "遵循JEDEC eMMC5.0/5.1标准, 将MMC接口、快闪存储器设备及主控制器封装于一…",
    "gxx": "采用先进工艺，功耗低、运行稳定。具备强大的处理能力，可满足多种复杂应用需求。为客户提供高效、可靠的解决方案，助力行业发展。"
  },
  "UFC": {
    "name": "嵌入式芯片",
    "js": "遵循JEDEC UFS3.1国际标准，兼容UFS2.2/2.1，支持128GB~1TB容量，将UFS…"
  },
  "M2": {
    "name": "储存模组",
    "zl": "M.2 SSD固态硬盘",
    "js": "基于SATA 3.0，采用M.2 SATA3.0接口，多尺寸结构，兼容性强，稳定可靠，…",
    "gxx": "拥有高容量、高速读写的特性，数据存储安全稳定。适用于各类电子设备，都能提供出色的存储解决方案。以先进技术和严格质量把控，满足不同客户的存储需求。"
  },
  "FB": {
    "name": "储存设备",
    "zl": "分布式存储设备",
    "js": "分布式存储设备，高效可靠。将数据分散存储在多台独立设备上，提高存储容量和可…",
    "gxx": "具备大容量空间，可轻松存储大量数据。读写速度快，响应迅速。设计坚固耐用，能适应各种复杂环境。提供安全、高效的存储体验，是数据存储的理想之选。"
  },
  "emd": {
    "em0": "采用先进工艺，功耗低、运行稳定。具备强大的处理能力，可满足多种复杂应用需求。为客户提供高效、可靠的解决方案，助力行业发展。",
    "em1": "遵循JEDEC eMMC5.0/5.1标准, 将MMC接口、快闪存储器设备及主控制器封装于一个小型BGA上，显著减少主机处理器上的存储管理负载。支持8GB~256GB容量段。具有快速、可升级的性能，同时其接口电压可以是1.8v或者是3.3v。超强兼容性，快速处理与主控制器及闪存的技术兼容问题。",
    "em2": "遵循JEDEC UFS3.1国际标准，兼容UFS2.2/2.1，支持128GB~1TB容量，将UFS接口、快闪存储器及主控制器，都集成在一个小型的BGA 封装内。UFS的串行数据传输技术具备高速度、高可靠性，抗干扰能力强，并能显著减少主机处理器上的存储管理负载。",
    "em3": "用闪存存储技术的硬盘，具有更快的读写速度和更低的能耗。它适用于需要快速启动和加载应用程序的场景。支持128GB~16TB容量段，标准外形尺寸是 2.5 英寸,接口为SATA3.0。",
    "em4": "支持128GB~16TB容量，高可靠性能，读写速度快，保证数据稳定高效传输，为工业、汽车和商业存储市场提供了更多的可靠性。",
    "em5": "512GB~16TB容量，读写速度快，高效传输，为数据中心、超算中心、AI算力平台提供更多的可靠产品。",
    "em6": "稳定读写，耐宽温，可做三防处理。",
    "em7": "具备大容量空间，可轻松存储大量数据。读写速度快，响应迅速。设计坚固耐用，能适应各种复杂环境。提供安全、高效的存储体验，是数据存储的理想之选。",
    "em8": "分布式存储设备，高效可靠。将数据分散存储在多台独立设备上，提高存储容量和可靠性。具备快速读写、灵活扩展的优势。适用于大规模数据存储场景，为企业和个人提供稳定、安全的存储解决方案，助力数据管理更便捷。",
    "em9": "集中式存储设备，性能稳定。整合存储资源于一处，方便管理与维护。提供高容量存储和快速数据访问。适用于企业级应用，确保数据安全集中管控。以强大的性能和可靠性，满足不同场景下的数据存储需求。",
    "em10": "存算阵列中心机柜，功能强大。集成存储与计算功能，高效处理海量数据。结构坚固，散热良好。为数据中心提供稳定可靠的运行环境。可灵活扩展，满足不断增长的业务需求，是现代数据处理的关键设备。",
    "em11": "数据系统集成阵列，高效整合。将多种设备和技术融合，实现数据的统一管理和存储。具备高可靠性和可扩展性。提升数据处理效率，为企业提供一站式数据解决方案，助力业务发展，是现代数据管理的有力工具。",
    "em12": "公司产品以创新为核，品质为基。在市场中独具优势，引领行业潮流，为客户带来卓越体验，共创美好未来。"
  },
  "canshu": {
    "can": "产品规格",
    "can0": "接口",
    "can1": "尺寸",
    "can2": "最大顺序读取速度",
    "can3": "最大顺序写入速度",
    "can4": "容量",
    "can5": "认证",
    "can6": "工作电压",
    "can7": "应用方向",
    "can8": "工作温度"
  },
  "datacenter": {
    "data0": "计算能力",
    "data1": "高性能处理器",
    "data2": "中央处理器（CPU）和图形处理器（GPU），以满足数据中心日益增长的计算需求，能够快速处理大规模的数据和复杂的计算任务。",
    "data3": "专用加速器",
    "data4": "专用的加速器芯片，能够加速深度学习模型的训练和推理，提高数据中心的计算效率。",
    "data5": "存储",
    "data6": "高速固态硬盘（SSD）",
    "data7": "中央处理器（CPU）和图形处理器（GPU），以满足数据中心日益增长的计算需求，能够快速处理大规模的数据和复杂的计算任务。",
    "data8": "内存扩展",
    "data9": "满足数据中心对大容量内存的需求，内存容量扩展到数 TB，提高数据中心的处理能力和响应速度。",
    "data10": "网络通信",
    "data11": "高速网络接口",
    "data12": "数据中心需要高速、低延迟的网络通信来连接服务器、存储设备和外部网络。支持高速网络协议的网络接口芯片，高性能网络协议的芯片，为数据中心提供了高速、可靠的网络通信解决方案。",
    "data13": "网络功能虚拟化（NFV）",
    "data14": "NFV 技术将传统的网络设备功能（如路由器、防火墙和负载均衡器）虚拟化，通过软件在通用服务器上实现。我们提供了高性能的处理器和网络接口芯片，支持虚拟化技术和软件定义网络（SDN），提高了数据中心的网络灵活性和可扩展性。",
    "data15": "高效率和安全性保障",
    "data16": "低功耗芯片设计",
    "data17": "采用先进的制程工艺和设计技术，降低芯片的功耗。通过优化芯片的架构和电源管理技术，进一步降低芯片的功耗。",
    "data18": "安全模块",
    "data19": "为了保障数据中心的安全性，可提供加密、认证和密钥管理等安全功能。可以保护数据中心的敏感数据和通信，防止黑客攻击和数据泄露。"
  },
  "pc": {
    "pc1": "计算性能",
    "pc2": "高性能处理器",
    "pc3": "更先进的中央处理器（CPU），增加核心数量、提高时钟频率和缓存大小，以满足客户端 PC 对强大计算能力的需求。快速处理多任务、复杂计算和大型软件应用，为用户提供流畅的使用体验。",
    "pc4": "专用计算芯片",
    "pc5": "专用的计算芯片，在图形处理和深度学习计算方面具有强大的性能，能够为游戏玩家提供逼真的游戏画面，也为专业用户在人工智能开发、视频特效制作等领域提供高效的计算支持。",
    "pc6": "存储",
    "pc7": "固态硬盘（SSD）",
    "pc8": "导体技术的发展使得 SSD 在客户端 PC 中得到广泛应用。SSD 具有更快的读写速度、更低的延迟和更高的可靠性，相比传统的机械硬盘（HDD），能够大大缩短系统启动时间、程序加载时间和文件传输时间。",
    "pc9": "内存技术",
    "pc10": "动态随机存取存储器（DRAM）是 PC 的重要内存组件，通过不断改进 DRAM 的制造工艺和技术，提高内存的容量和频率，以满足日益增长的软件对内存的需求。",
    "pc11": "网络通信",
    "pc12": "有线网络芯片",
    "pc13": "以太网是客户端 PC 最常用的有线网络连接方式，半导体厂商提供的以太网控制器芯片，支持高速的网络传输速率，如千兆以太网、万兆以太网等，确保 PC 能够快速、稳定地连接到网络。此外，一些网络芯片还支持网络唤醒、远程管理等功能，方便用户对 PC 进行远程控制和管理。",
    "pc14": "无线网络芯片",
    "pc15": "无线网络的普及使得客户端 PC 对无线网络芯片的需求不断增加。蓝牙芯片也是客户端 PC 的常见无线通信组件，用于连接蓝牙设备，如耳机、鼠标、键盘等。",
    "pc16": "安全保障",
    "pc17": "硬件加密芯片",
    "pc18": "为了保护用户的隐私和数据安全，使用硬件加密芯片。这些芯片可以对存储在 PC 中的数据进行加密处理，防止数据被未经授权的访问和窃取。例如，一些笔记本电脑采用了指纹识别或面部识别技术，其背后的芯片能够对用户的生物特征信息进行加密存储和验证，确保只有合法用户能够访问系统和数据。",
    "pc19": "安全启动芯片",
    "pc20": "安全启动芯片用于确保 PC 在启动过程中的安全性。它可以验证操作系统和其他关键系统文件的完整性和真实性，防止恶意软件在启动过程中加载和运行。这种芯片能够有效地抵御病毒、木马等恶意程序的攻击，保护 PC 的系统安全。"
  },
  "car": {
    "pc1": "智能座舱",
    "pc2": "信息娱乐系统",
    "pc3": "为车载信息娱乐系统提供强大的计算和处理能力，支持高清视频播放、音频处理、导航、蓝牙连接等多种功能。例如，高性能的微处理器（CPU）和图形处理器（GPU）可以实现流畅的人机交互界面和丰富的多媒体体验。",
    "pc4": "显示屏控制",
    "pc5": "随着汽车座舱内显示屏的数量和尺寸不断增加，芯片用于驱动和控制液晶显示屏（LCD）、有机发光二极管（OLED）等各种显示屏，实现高分辨率、高刷新率的显示效果。",
    "pc6": "智能交互",
    "pc7": "支持语音识别、手势识别、面部识别等智能交互功能，使驾驶员和乘客能够更方便地操作车内设备。例如，麦克风阵列芯片、摄像头传感器芯片等可以采集和处理用户的语音和图像信息，实现智能交互。",
    "pc8": "自动驾驶",
    "pc9": "传感器融合",
    "pc10": "自动驾驶汽车需要多种传感器来感知周围环境，如摄像头、毫米波雷达、激光雷达等。芯片用于处理和融合这些传感器的数据，提高环境感知的准确性和可靠性。",
    "pc11": "计算平台",
    "pc12": "强大的计算平台是实现自动驾驶的核心，半导体芯片作为计算平台的核心部件，承担着大量的计算任务。",
    "pc13": "通信模块",
    "pc14": "自动驾驶汽车需要与其他车辆、基础设施和云端进行通信，芯片用于实现车联网（V2X）通信功能。",
    "pc15": "车身电子系统",
    "pc16": "电子控制单元（ECU）",
    "pc17": "汽车的各种电子控制单元，如发动机控制单元（ECU）、变速箱控制单元（TCU）、车身控制模块（BCM）等，都依赖半导体芯片来实现对车辆各系统的控制和管理。这些芯片可以实时监测和处理车辆的各种信号，实现对发动机、变速箱、制动系统、灯光系统等的精确控制。",
    "pc18": "电源管理",
    "pc19": "用于汽车的电源管理系统，包括电压转换、稳压、电源分配等功能。",
    "pc20": "安全系统",
    "pc21": "在汽车安全系统中也起着重要作用，如安全气囊控制芯片、防抱死制动系统（ABS）芯片、电子稳定控制系统（ESC）芯片等。这些芯片能够快速响应车辆的安全状况，确保在紧急情况下安全系统的及时启动和有效工作。"
  },
  "mobile": {
    "pc1": "性能",
    "pc2": "处理器芯片",
    "pc3": "移动设备的中央处理器（CPU）和图形处理器（GPU）是核心部件，半导体技术的不断进步使得这些芯片的性能持续提升。处理器的运算速度、处理能力和能效比，为移动设备提供了强大的计算能力，支持高清视频播放、大型游戏运行、多任务处理等复杂应用。",
    "pc4": "内存芯片",
    "pc5": "动态随机存取存储器（DRAM）和闪存（Flash）等内存芯片对于移动设备的性能也至关重要。更高容量和更快速度的 DRAM 可以让移动设备在运行多个应用程序时更加流畅，减少卡顿现象；而闪存芯片则用于存储操作系统、应用程序、用户数据等信息，快速的闪存读写速度能够加快应用的启动时间和数据的传输速度。",
    "pc6": "通信连接",
    "pc7": "基带芯片",
    "pc8": "基带芯片是移动设备实现通信功能的关键部件，负责对无线信号进行调制和解调、编码和解码等处理。随着 5G 技术的发展，5G 基带芯片成为市场的焦点，它能够支持更高的数据传输速率、更低的延迟和更大的连接密度，为移动设备带来更快的网络下载和上传速度，以及更流畅的高清视频通话、在线游戏等体验。",
    "pc9": "射频芯片",
    "pc10": "射频芯片用于处理移动设备的无线射频信号，包括信号的发射和接收、频率的转换、功率的放大等功能。良好的射频芯片能够提高移动设备的信号接收灵敏度、信号覆盖范围和抗干扰能力，确保在不同的环境下都能保持稳定的通信连接。",
    "pc11": "显示与视觉",
    "pc12": "显示驱动芯片",
    "pc13": "移动设备的显示屏需要显示驱动芯片来控制像素的点亮和颜色的显示。高分辨率、高刷新率、高对比度的显示屏需要更强大的显示驱动芯片来支持。",
    "pc14": "视觉处理芯片",
    "pc15": "为了提升移动设备的拍照、视频录制和图像显示效果，视觉处理芯片发挥着重要作用。这类芯片可以对图像传感器采集到的原始图像数据进行处理和优化，包括去噪、增强对比度、色彩校正、自动对焦、光学防抖等功能，使拍摄出的照片和视频更加清晰、细腻、色彩鲜艳。",
    "pc16": "传感器与交互",
    "pc17": "传感器芯片",
    "pc18": "移动设备配备了多种传感器，如加速度传感器、陀螺仪、磁力计、光线传感器、距离传感器等，这些传感器需要相应的传感器芯片来进行数据采集和处理。传感器芯片能够将物理量转换为电信号，并传输给处理器进行分析和处理，从而实现各种功能，如自动旋转屏幕、计步、导航、环境光感应等。例如，在游戏应用中，加速度传感器和陀螺仪可以实现体感操作，增强游戏的交互性和趣味性。",
    "pc19": "指纹识别芯片和面部识别芯片",
    "pc20": "生物识别技术在移动设备中得到广泛应用，指纹识别芯片和面部识别芯片为移动设备提供了安全、便捷的解锁方式。指纹识别芯片可以快速准确地识别用户的指纹信息，面部识别芯片则通过摄像头采集用户的面部图像，并进行识别和验证。这些生物识别芯片不仅提高了移动设备的安全性，还方便了用户的日常使用。",
    "pc21": "异构计算与人工智能",
    "pc22": "异构计算芯片",
    "pc23": "移动设备中的应用场景越来越复杂，需要同时处理多种不同类型的任务，如计算密集型的游戏、图形处理任务，以及通信、传感器数据处理等任务。异构计算芯片将不同类型的处理器核心集成在一起，如 CPU、GPU、DSP（Digital Signal Processor）、NPU（Neural Processing Unit）等，根据不同任务的需求自动分配计算资源，提高设备的整体性能和能效比。",
    "pc24": "人工智能芯片",
    "pc25": "随着人工智能技术在移动设备中的应用不断深入，专门的人工智能芯片逐渐成为移动设备的重要组成部分。这些芯片针对人工智能算法进行了优化，能够高效地运行深度学习模型，实现智能语音助手、智能拍照、智能翻译等功能。"
  },
  "ai": {
    "pc1": "计算能力",
    "pc2": "图形处理单元（GPU）",
    "pc3": "其并行处理能力和高内存带宽，非常适合深度学习模型中的矩阵运算和数据并行性，已成为人工智能训练和推理的重要硬件。",
    "pc4": "现场可编程门阵列（FPGA）",
    "pc5": "具有可重新编程的特性，能够配置为实现定制硬件架构。它的灵活性和并行性对于加速人工智能任务具有吸引力，开发者可以根据特定的神经网络模型或算法需求，实现自定义逻辑，从而满足不同人工智能应用的多样化需求",
    "pc6": "芯片架构优化",
    "pc7": "不断研发新的芯片架构，以提高芯片在人工智能计算中的效率。例如，采用多核心、异构计算架构，将不同类型的处理器核心集成在一起，如 CPU、GPU、专用加速器等，利用每个组件的优势来优化不同人工智能任务的执行，从而提高整体性能和效率",
    "pc8": "数据存储与传输",
    "pc9": "存储芯片技术改进",
    "pc10": "固态硬盘（SSD）等半导体存储技术的不断发展，提高了数据的读写速度和存储容量。这使得人工智能系统能够更快地加载和保存数据，减少数据存储和访问的时间成本，为人工智能的实时应用提供了支持。",
    "pc11": "高速数据传输接口",
    "pc12": "半导体技术推动了高速数据传输接口的发展，如 PCIe 等。这些接口能够实现芯片之间、芯片与外部设备之间的高速数据传输，确保人工智能系统中各个组件之间的数据流通顺畅，提高系统的整体性能。",
    "pc13": "传感器与数据采集",
    "pc14": "图像传感器",
    "pc15": "在人工智能的计算机视觉应用中，图像传感器是关键的部件。半导体技术的发展使得图像传感器的分辨率不断提高、噪声降低、动态范围增大，能够采集到更清晰、更准确的图像数据。",
    "pc16": "语音传感器",
    "pc17": "对于人工智能的语音处理应用，语音传感器负责将声音信号转换为电信号。半导体技术的进步提高了语音传感器的灵敏度和信噪比，能够更准确地采集语音数据。同时，结合语音信号处理芯片和人工智能算法，实现了语音识别、语音合成等功能，为智能语音助手、语音交互系统等应用提供了技术支持。"
  },
  "smart": {
    "pc1": "智能电子设备",
    "pc2": "智能手机",
    "pc3": "高性能处理器芯片确保手机运行流畅，快速处理多任务和复杂应用。先进的图像传感器芯片提升拍照质量。大容量存储芯片如闪存（NAND Flash），让用户可以存储大量的照片、视频、音乐和应用程序。同时，快速的内存芯片（DRAM）确保应用的快速启动和切换。",
    "pc4": "平板电脑",
    "pc5": "与智能手机类似，平板电脑也依赖高性能处理器、大容量存储和快速通信芯片。此外，高分辨率的显示屏需要显示驱动芯片来提供清晰、鲜艳的图像。平板电脑还常配备触控芯片，实现灵敏的触摸操作和手势识别，提升用户交互体验。",
    "pc6": "智能手表和可穿戴设备",
    "pc7": "低功耗处理器芯片满足可穿戴设备对续航能力的要求。传感器芯片如心率传感器、加速度传感器、陀螺仪等，监测用户的健康数据和运动状态。这些传感器芯片能够准确地测量心率、步数、睡眠质量等信息，为用户提供个性化的健康管理和运动建议。蓝牙芯片实现与智能手机等设备的无线连接，方便用户接收通知、控制音乐播放等。",
    "pc8": "家庭娱乐设备",
    "pc9": "智能电视",
    "pc10": "高分辨率显示芯片和图像处理芯片提供清晰、逼真的图像质量。智能电视通常配备操作系统和应用程序，需要高性能的处理器芯片来支持流畅的运行。同时，存储芯片用于存储应用程序和用户数据。无线通信芯片实现与网络的连接，支持流媒体播放、在线游戏等功能。",
    "pc11": "音响设备",
    "pc12": "数字信号处理芯片（DSP）优化音频信号，实现音效增强、噪声消除等功能。蓝牙和 Wi-Fi 芯片实现无线音频传输，方便用户连接智能手机、平板电脑等设备，播放音乐和视频。功率放大器芯片驱动扬声器，提供强大的音频输出。不同功率和性能的功率放大器芯片适用于不同类型的音响设备，从便携式蓝牙音箱到家庭影院系统。",
    "pc13": "游戏主机",
    "pc14": "高性能处理器和图形处理器芯片提供强大的游戏性能。存储芯片用于存储游戏数据和安装游戏软件。快速的固态硬盘（SSD）可以缩短游戏加载时间，提高游戏的流畅度。",
    "pc15": "智能家居设备",
    "pc16": "智能家电",
    "pc17": "微控制器芯片（MCU）控制家电的运行和功能。传感器芯片监测环境参数，如温度、湿度、空气质量等。这些传感器芯片为智能家电提供了智能化的控制依据，实现自动调节和节能运行。通信芯片实现家电与智能手机、智能家居中枢等设备的连接，支持远程控制和智能化管理。",
    "pc18": "智能照明系统",
    "pc19": "照明控制芯片实现灯光的亮度调节、颜色变化、定时开关等功能。传感器芯片如光敏传感器、人体感应传感器等，实现自动照明控制。通信芯片支持智能照明系统与智能家居网络的连接，实现集中控制和智能化管理。",
    "pc20": "智能安防系统",
    "pc21": "视频监控芯片处理摄像头采集的图像信号，实现高清视频录制、运动检测、人脸识别等功能。传感器芯片如门窗传感器、烟雾传感器、燃气传感器等，监测家庭的安全状态。通信芯片实现安防系统与用户手机、安防监控中心等设备的连接，确保及时的报警通知和远程监控。"
  },
  "NET": {
    "pc1": "数据传输与交换",
    "pc2": "高速网络芯片",
    "pc3": "以太网芯片负责在局域网（LAN）和广域网（WAN）中实现高速数据传输。光通信芯片在光纤通信系统中起着关键作用。包括光发射芯片和光接收芯片，用于将电信号转换为光信号进行传输，以及将光信号转换回电信号进行接收。交换芯片用于网络交换机和路由器中，实现数据包的快速转发和路由选择。",
    "pc4": "无线通信芯片",
    "pc5": "Wi-Fi 芯片为无线网络提供连接支持。蜂窝通信芯片用于移动通信网络，如 4G、5G 等。这些芯片支持手机、平板电脑和其他移动设备与电信运营商的网络进行连接，实现语音通话、数据传输和移动互联网应用。蓝牙芯片主要用于短距离无线通信，连接各种设备，如耳机、音箱、键盘、鼠标等。蓝牙芯片不断演进，提供更高的传输速度、更低的功耗和更稳定的连接，方便用户在各种场景下使用无线设备。",
    "pc6": "数据存储与处理",
    "pc7": "存储芯片",
    "pc8": "固态硬盘（SSD）控制器芯片在 SSD 中负责管理闪存芯片的读写操作和数据存储。这些芯片采用先进的算法和纠错技术，提高 SSD 的性能、可靠性和寿命。内存芯片包括动态随机存取存储器（DRAM）和静态随机存取存储器（SRAM）等，用于存储计算机和网络设备运行时的数据。高速、大容量的内存芯片对于网络基础设施中的服务器、路由器和交换机等设备至关重要，能够提高数据处理速度和系统性能。",
    "pc9": "网络处理器",
    "pc10": "专门为网络应用设计的处理器芯片，具有强大的数据包处理能力和并行计算能力。网络处理器可以实现高速的数据包分类、转发、加密、压缩等功能，满足网络流量不断增长的需求。",
    "pc11": "网络安全与管理",
    "pc12": "安全芯片",
    "pc13": "加密芯片用于对网络数据进行加密和解密，保护数据的安全性和隐私性。身份认证芯片用于网络设备和用户的身份认证。例如，在企业网络和数据中心中，身份认证芯片可以实现双因素认证、生物识别认证等安全认证方式，确保只有合法的用户和设备能够访问网络资源。",
    "pc14": "网络管理芯片",
    "pc15": "用于网络设备的管理和监控，实现远程配置、故障诊断和性能优化等功能。支持网络协议栈的芯片，如 SNMP（简单网络管理协议）芯片，使得网络管理员可以方便地对网络设备进行集中管理和控制，提高网络管理的效率和精度。"
  },
  "Ind": {
    "pc1": "智能传感器与数据采集",
    "pc2": "高精度传感器芯片",
    "pc3": "压力传感器芯片用于监测工业设备中的压力变化，确保设备在安全的压力范围内运行。温度传感器芯片对工业生产过程中的温度进行精确测量。位移传感器芯片测量物体的位移和位置变化。",
    "pc4": "多参数传感器融合芯片",
    "pc5": "将多种传感器功能集成在一个芯片上，实现对多个参数的同时监测。例如，集成了温度、湿度、压力、加速度等多种传感器的芯片，可以用于工业环境监测和设备状态监测。在智能工厂中，这种多参数传感器融合芯片可以实时采集生产环境和设备运行状态的信息，为生产过程的优化和设备维护提供数据支持。",
    "pc6": "无线传感器网络芯片",
    "pc7": "实现传感器之间的无线通信，构建工业互联网中的无线传感器网络。可以在工业环境中实现低功耗、远距离的传感器数据传输。在大型工厂和工业园区中，无线传感器网络芯片可以方便地部署和扩展，降低布线成本，提高系统的灵活性和可维护性。",
    "pc8": "工业通信与网络连接",
    "pc9": "工业无线通信芯片",
    "pc10": "包括 Wi-Fi、5G、蓝牙等无线通信技术的芯片，为工业互联网提供灵活的无线连接解决方案。在一些难以布线或需要移动设备连接的工业场景中，工业无线通信芯片可以实现设备的无线通信和远程控制。例如，在智能仓储和物流系统中，芯片可以实现高速的数据传输和低延迟的控制，提高物流效率和准确性。",
    "pc11": "工业网关芯片",
    "pc12": "连接不同的工业通信协议和网络，实现数据的转换和传输。工业网关芯片可以将现场设备的各种通信协议（如 Modbus、Profibus 等）转换为统一的网络协议（如 TCP/IP），实现不同设备之间的互联互通。例如，在工业自动化系统中，工业网关芯片可以将现场的传感器、控制器等设备连接到企业的网络管理系统，实现远程监控和管理。",
    "pc13": "工业控制与自动化",
    "pc14": "微控制器（MCU）和数字信号处理器（DSP）芯片",
    "pc15": "作为工业控制系统的核心芯片，负责控制和协调工业设备的运行。MCU 和 DSP 芯片具有高性能、低功耗、丰富的外设接口等特点，能够满足工业自动化系统对实时性、可靠性和精度的要求。",
    "pc16": "可编程逻辑控制器（PLC）芯片",
    "pc17": "用于工业自动化系统中的逻辑控制和顺序控制。PLC 芯片具有高可靠性、抗干扰能力强、编程灵活等特点，能够适应复杂的工业环境。例如，在制造业、能源、交通等行业的自动化生产线和控制系统中，PLC 芯片可以实现对设备的自动化控制和故障诊断。",
    "pc18": "工业专用芯片",
    "pc19": "针对特定的工业应用领域开发的专用芯片，如电机驱动芯片、电源管理芯片、传感器信号处理芯片等。这些芯片具有高度的专业性和针对性，能够满足特定工业应用的特殊要求。",
    "pc20": "工业安全与可靠性",
    "pc21": "安全芯片",
    "pc22": "用于工业互联网中的数据加密、身份认证和访问控制。安全芯片可以保护工业设备和系统的数据安全，防止数据被窃取、篡改和恶意攻击。例如，在工业控制系统中，安全芯片可以实现对设备的身份认证和访问控制，确保只有授权的用户和设备能够访问系统。",
    "pc23": "容错芯片",
    "pc24": "提高工业设备和系统的可靠性和容错能力。容错芯片可以检测和纠正硬件故障，确保系统在出现故障时仍能继续运行。例如，在航空航天、铁路交通等对可靠性要求极高的行业，容错芯片可以提高系统的安全性和稳定性。",
    "pc25": "可靠性测试芯片",
    "pc26": "于对工业芯片进行可靠性测试和验证。可靠性测试芯片可以模拟各种恶劣的工作环境和应力条件，对芯片的性能和可靠性进行测试和评估。例如，在芯片制造过程中，可靠性测试芯片可以检测芯片的寿命、抗干扰能力、温度稳定性等指标，确保芯片的质量和可靠性。"
  },
  "abv": {
    "ab1": "为数据中心提供高性能芯片，用于计算、存储与网络传输，优化能耗与散热，助力数据中心高效运作。",
    "ab2": "浙江新甚科技有限公司-半导体存储系列产品生产制造配套的技术企业",
    "ab3": "主要产品应用于消费级SSD、高性能ESSD：系统级固态盘、企业级数据盘；存储设备类：NAS、SAN、存算一体的数据机柜等。",
    "ab4": "具备NAND FLASH 、DDR系列、LPDDR系列及嵌入式存储芯片（eMMC 、UFS 、uMCP 、eSSD）的封装及测试量产能力，并可实现多层次多种类的芯片叠加的SiP封装、高密度低功耗芯片的封装（HBM）等。",
    "ab5": "已获ISO9001 、BSCI 、CE、3C、FCC、RoHs等多项认证半导体专委会、科创联盟副理事长单位。",
    "ab6": "成为全球半导体创新引领者，以卓越技术塑造智能未来，让生活因科技而璀璨。",
    "ab7": "推动半导体技术进步，赋能各行业智能化升级，为客户创造极致价值，为社会贡献科技力量。",
    "ab8": "品质至上，追求卓越工艺，铸就可靠产品。",
    "ab9": "技术优势",
    "ab10": "公司拥有一支专业的研发团队，他们在半导体领域拥有深厚的专业知识和创新能力，能够为客户提供高性能、低功耗、高可靠性的半导体产品。",
    "ab11": "产品优势",
    "ab12": "公司的产品具有卓越的性能和高可靠性，能够满足不同客户的需求，为客户提供一站式的半导体解决方案。",
    "ab13": "市场优势",
    "ab14": "公司的半导体产品广泛应用于消费电子、通信、汽车、工业控制等多个领域，拥有众多的国内外客户，为客户提供优质的产品和服务。",
    "ab15": "品牌优势",
    "ab16": "公司注重产品质量和服务水平的提升，通过不断的技术创新和市场拓展，赢得了客户的信任和好评。"
  },
  "gc": {
    "gc1": "我们的工厂实力雄厚，拥有先进设备与专业团队。严格把控质量，致力于为客户提供优质产品与高效服务。",
    "gc2": "工厂优势",
    "gc3": "车间标准",
    "gc4": "高标准净化车间7000m²",
    "gc5": "封测产线（千级净化）",
    "gc6": "模组产线（万级净化）",
    "gc7": "产线优势",
    "gc8": "专用产线5条，设备360+台",
    "gc9": "SIP、Chiplet、HBM等高精密先进封装",
    "gc10": "品牌客户配套专用SSD生产线4条",
    "gc11": "专用打样产线可快速研制出样、小批量排单",
    "gc12": "质量优势",
    "gc13": "严格遵照 ISO9001质量体系标准，严控品质",
    "gc14": "被多家上市企业持续多年称为“优秀合作商”",
    "gc15": "宏杉科技、亿次，板卡生产测试产线",
    "gc16": "国产GPU战略合作商",
    "gc17": "高校科创联盟（半导体先进技术院士工作站）",
    "gc18": "SMT车间",
    "gc19": "SMT 贴片是表面组装技术。将电子元件贴装在 PCB 板表面，通过回流焊等工艺实现电气连接。具有高集成度、高效率、高质量等优点，广泛应用于电子制造领域，为电子产品的小型化、智能化提供有力支持。",
    "gc20": "测试车间",
    "gc21": "SSD 测试主要包括读写速度、随机读写性能、稳定性等方面。通过专业软件进行测试，可评估 SSD 的性能表现。良好的 SSD 能快速响应，提升系统运行效率，为你的设备带来更流畅的使用体验。",
    "gc22": "品质部",
    "gc23": "确保产品质量的关键部门。拥有专业检测设备和严格的质检流程。从原材料到成品，层层把关，致力于为客户提供高品质的产品。以严谨的态度和专业的精神，为企业的发展保驾护航。"
  },
  "cont": {
    "con1": "无论你有疑问、建议还是需求，都可随时与我们沟通，我们将竭诚为你服务。",
    "con2": "请与我们联系",
    "con3": "请联系我们，我们会尽快联系您",
    "con4": "名",
    "con5": "电子邮件",
    "con6": "公司",
    "con7": "姓",
    "con8": "电话",
    "con9": "国家/地区",
    "con10": "其他信息",
    "con11": "发送",
    "con12": "联系我们",
    "con13": "联系电话",
    "con14": "商务合作",
    "con15": "公司地址",
    "con16": "浙江省湖州市吴兴区织里镇鹏飞路1888号4号楼"
  },
  "sale": {
    "sa1": "销售与技术支持团队紧密合作，共同为客户创造价值。他们以客户为中心，不断提升自身的业务水平和服务质量，为企业的发展和客户的成功贡献着自己的力量。",
    "sa2": "新甚质量基石",
    "sa3": "销售服务",
    "sa4": "优秀的技术团队支持",
    "sa5": "我们的公司技术团队是一支充满活力与创新的精英队伍。团队成员均拥有扎实的专业知识和丰富的实践经验，他们致力于半导体技术的研发与创新，不断探索前沿科技。技术团队紧密合作，以严谨的态度对待每一个环节。他们追求卓越品质，确保公司产品在性能、稳定性等方面有一定水平。",
    "sa6": "原材料供应商",
    "sa7": "公司高度重视原材料供应商管理。设立严格的准入标准，审核供应商资质。定期对其进行品质抽检，监督生产过程。要求及时提供检测报告，确保原材料质量稳定。以有力的监督举措，为公司产品质量提供坚实保障。",
    "sa8": "工序之间的半成品供应",
    "sa9": "公司秉持品质至上理念。拥有专业的品质检测团队，配备先进检测设备。对产品进行严格的全流程检测，不放过任何一个细节。确保每一个出厂产品都符合高品质标准，以卓越品质赢得客户信赖，为公司发展奠定坚实基础。",
    "sa10": "优质的客户服务",
    "sa11": "提供一对一的专人服务，无忧又省心",
    "sa12": "灵活的销售政策",
    "sa13": "根据市场需求和客户情况，制定灵活的销售政策。",
    "sa14": "高质量交付",
    "sa15": "全程把控产品质量，可定制开发"
  },
  "zl": {
    "zl1": "车载、平板、工控机、无人机",
    "zl2": "高端智能手机、服务器",
    "zl3": "高端智能手机、服务器",
    "zl4": "台式电脑、服务器、工控机",
    "zl5": "笔记本电脑、平板电脑",
    "zl6": "车规级、加固笔记本电脑、工控机",
    "zl7": "数据中心、智算中心、企业级专网用户",
    "zl8": "车规级、加固笔记本电脑、工控机",
    "zl9": "单位数据保护、小型数据中心",
    "zl10": "大型数据中心、智算中心、云计算中心",
    "zl11": "大型数据中心、智算中心、云计算中心",
    "zl12": "大型数据中心、智算中心、云计算中心、数据集群项目"
  },
  "news": {
    "canton": {
      "title": "新甚科技亮相广交会70周年盛会",
      "desc": "创新产品赋能海外市场开拓",
      "b1": "值广交会创办70周年之际，新甚科技由董事长石李荣带队参展，携多款自研新品登陆电子电气、电子消费品及信息产品展区。企业依托广交会这一国家级对外开放平台，积极对接全球客商，全力拓展海外市场。",
      "b2": "作为新大集团重点参展单位，新甚科技紧扣海外市场需求，集中展出多款自主研发新品。丰富的产品矩阵吸引众多海外采购商驻足参观、洽谈合作，展位现场商务交流氛围热烈。",
      "b3": "展会期间，新大集团董事长林昌斌莅临新甚科技展位视察指导，听取参展团队关于新品研发、客商对接、意向订单推进等工作汇报，并与海外采购商现场交流，深入了解海外市场政策与需求变化。林昌斌充分肯定本次参展筹备工作及新品竞争力，勉励企业用好广交会平台，抢抓订单机遇，扩大海外客户“朋友圈”；紧跟行业前沿，加快技术迭代，打造更多适销对路的拳头产品，挖掘外贸增长新空间。",
      "b4": "新甚科技董事长石李荣陪同接待并汇报参展情况。石李荣表示，广交会是企业直面海外客户、感知市场风向的重要窗口。公司将落实集团部署，紧抓广交会70周年机遇，深耕海外市场，坚持创新驱动，打磨优质产品，拓展海外优质客户，持续提升国际市场竞争力。",
      "b5": "下一步，新甚科技将坚守创新发展理念，依托广交会对外交流窗口，持续深耕国际市场，聚力产品技术升级，增强国际化经营能力，奋力开创外贸高质量发展新局面。"
    },
    "ew1": "转：多重利好提振！半导体逆市上攻，涨势可期？",
    "ew2": "根据SEMI的预测，2024年全球半导体设备销售额预计同比增长3.4%至1090亿美元。中国对半导体设备投资将持续强劲，投入芯片设备将占据全球32%的份额。预计到2027年，中国将保持其作为全球300mm设备支出第一的地位，未来三年将投资超过1000亿美元。",
    "ew3": "转：让水稻生出半导体材料！中国团队成功实现：纯度99.99%",
    "ew4": "武汉科技大学宣布，该校材料学部“志同‘稻’合”学生团队采用低温镁热技术，成功从稻杆、稻壳中提取制作一种半导体材料——纳米碳化硅。其纯度高达99.99%，颗粒尺寸可细达30nm，使稻壳附加值提升9倍以上。据了解，纳米碳化硅作为一种重要的半导体材料，广泛应用于芯片制造和高端陶瓷等领域，全球对其需求量巨大。",
    "ew5": "转：半导体行业有望迈入新一轮增长周期",
    "ew6": "受下游需求逐步回暖复苏和行业公司在研发创新上不断发力，半导体行业整体业绩向好，迎来新一轮成长周期。据美国半导体行业协会发布的数据显示，全球半导体产业销售额在2024年第二季度累计达到了1499亿美元，同比增长18.3%，环比增长6.5%。",
    "ew7": "炎炎夏日送清凉 深情关怀暖人心——新甚领导慰问一线员工",
    "ew8": "夏日的骄阳似火，大地如同蒸笼一般，酷热难耐。然而，在这样的高温天气下，新甚科技的一线员工们依然坚守岗位，为了公司的发展默默奉献着自己的力量。为了表达对这些辛勤劳动者的关怀和敬意，公司领导决定开展一场夏日慰问活动，为一线员工送去清凉与关爱。",
    "ew9": "7nm等光刻机没有也无妨！中国半导体行业协会理事长：先进封装是未来",
    "ew10": "据国内媒体报道称，中国半导体行业协会理事长陈南翔近日接受采访时表示，中国集成电路产业仍在路上，未来一定孕育巨大成功模式。“在40年前，我不曾想过中国半导体产业能有如今的发展规模，但是在过去的20年我们可以清楚的看到，未来中国一定会有今天这样的发展。”陈南翔称，不过，当下还不是中国半导体产业最好的发展状态，中国最好的状态正在路上。",
    "skills": {
      "title": "技赢未来，匠筑新甚",
      "desc": "技能人才乃立业之本，工匠精神是兴业之魂。为大力弘扬劳模精神、劳动精神、工匠精神，夯实智能制造生产根基，锤炼高素质技能人才队伍，营造勤学苦练、精益求精、创先争优的干事氛围，新甚科技成功举办首届 SMT“工匠杯” 技能大赛，本次赛事圆满落下帷幕。",
      "b1": "技能人才乃立业之本，工匠精神是兴业之魂。为大力弘扬劳模精神、劳动精神、工匠精神，夯实智能制造生产根基，锤炼高素质技能人才队伍，营造勤学苦练、精益求精、创先争优的干事氛围，新甚科技成功举办首届 SMT“工匠杯” 技能大赛，本次赛事圆满落下帷幕。",
      "b2": "本次大赛聚焦 SMT 生产核心岗位，面向车间全体一线在岗技术人员开展，坚持以赛促学、以赛促练、以赛促干、以赛促升的赛事宗旨。比赛采用 “理论笔试 + 现场实操” 双线考核模式，严格对标行业高标准、企业严规范，考核内容全面覆盖专业理论知识、精密设备运维、物料精细管控、产品质量判定、现场 6S 标准化管理等核心模块。赛场上，选手们沉着应战、精益求精，以扎实功底和娴熟技艺展开激烈比拼。评审团队秉持公平公正公开原则，紧扣行业标准、生产规范、岗位要求严谨评审，精准甄别技能短板，有效检验了人才培育成果，充分展现了一线技术人员锐意进取、务实笃行的良好风貌。",
      "b3": "以技立业，以匠致远。本次大赛是公司夯实人才战略、深化技能队伍建设、赋能生产提质增效的重要举措。下一步，新甚科技将以大赛为重要契机，总结赛事成果、梳理岗位短板、精准靶向赋能，常态化开展专项技能培训，全力打造专业化、复合型、高素质智能制造人才梯队。同时持续厚植工匠文化，深耕实业主业，营造比、学、赶、帮、超的浓厚干事氛围，以精湛技能筑牢生产根基，以匠心实干赋能企业发展，奋力书写智能制造高质量发展新篇章！匠心筑梦，技赢未来，新甚明天需你我共同书写！"
    },
    "summer": {
      "title": "清凉一夏 情系新甚 集团领导莅临新甚科技开展夏日送清凉慰问",
      "desc": "盛夏时节，热浪来袭，新甚科技全体职工坚守生产一线，保障各条生产线稳定运转。为扎实做好夏季职工关怀，守护员工身心健康，筑牢安全生产防线，新大集团领导深入公司生产车间，走访慰问一线在岗职工，把暖心关怀送到生产现场。",
      "b1": "盛夏时节，热浪来袭，新甚科技全体职工坚守生产一线，保障各条生产线稳定运转。为扎实做好夏季职工关怀，守护员工身心健康，筑牢安全生产防线，新大集团领导深入公司生产车间，走访慰问一线在岗职工，把暖心关怀送到生产现场。",
      "b2": "走访中，集团领导与在岗职工亲切交谈，详细了解员工作业状态、轮班休整及后勤保障情况，高度肯定大家坚守产线、稳产保供的辛勤付出。领导重点叮嘱，各班组要科学排布生产计划，避免疲劳作业，抓实安全管理。集团及公司将持续优化后勤保障，为职工安心作业、舒心工作筑牢保障。",
      "b3": "慰问现场，公司领导为在岗职工发放解暑饮品、日用生活用品等清凉物资，一份份慰问品饱含组织的牵挂，为坚守岗位的职工带去夏日清凉。"
    },
    "inspect": {
      "title": "省供销社副主任董益彪赴新甚科技有限公司调研指导工作",
      "desc": "5月8日，省供销社党委委员、理事会副主任董益彪带队莅临我司，就经营管理工作开展调研。新大集团党委书记、董事长林昌斌参与调研，我司相关负责人全程陪同。",
      "b1": "5月8日，省供销社党委委员、理事会副主任董益彪带队莅临我司，就经营管理工作开展调研。新大集团党委书记、董事长林昌斌参与调研，我司相关负责人全程陪同。",
      "b2": "调研期间，董益彪一行参观了我司生产车间，详细了解从晶圆测试到模组封装的完整产业链，认真听取我司市场开拓、产品研发和安全生产等情况汇报。董益彪指出，半导体存储业务是新大集团践行科工贸战略、培育新质生产力的重要成果。他要求我司积极应对市场波动，加强应收账款管理、改善经营质效，加大研发投入、提升产品科技含量，深化行业研究、做好长远规划，加快向行业头部地位迈进。"
    },
    "award": {
      "title": "深耕存储芯片赛道 以科技创新驱动企业高质量发展",
      "desc": "【新甚科技讯】近日，我司荣获兴合集团 2025 年度创利优秀企业二等奖。继 2024 年度斩获兴合集团创利优秀企业三等奖后，公司连续两年获此表彰，充分肯定了企业成立以来在经营效益、科技创新上取得的扎实成果。公司同步获评 “浙江省创新型中小企业”，技术研发与市场拓展工作取得阶段性突破。",
      "b1": "【新甚科技讯】近日，我司荣获兴合集团 2025 年度创利优秀企业二等奖。继 2024 年度斩获兴合集团创利优秀企业三等奖后，公司连续两年获此表彰，充分肯定了企业成立以来在经营效益、科技创新上取得的扎实成果。公司同步获评 “浙江省创新型中小企业”，技术研发与市场拓展工作取得阶段性突破。",
      "b2": "浙江新甚科作为省属国企新大集团重点培育的科创主体，公司聚焦半导体存储芯片及模组测试主业，面向智算中心、车规工控、消费电子等领域提供算存一体测试解决方案，具备 NAND FLASH、DDR、LPDDR、EMMC、UFS 等主流存储芯片完整测试量产能力，构建起从预研开发、快速打样到批量交付的全流程服务体系。",
      "b3": "公司始终坚持创新驱动发展导向，持续加大科研经费投入。目前落地实施 13 项重点研发课题，重点开展微焊点质量检测、PCBA 智能首件测试、长时高温老化检测等工艺技术攻关。针对行业测试效率不高、缺陷检测精度不足等现实难题，推进测试程序优化升级、三维无损成像检测应用、芯片失效分析诊断、复杂工况环境模拟测试等技术研究，存储芯片测试效率较行业平均水平提升 15% 以上。取得 ISO9001、BSCI、CE 等 6 项权威资质认证。",
      "b4": "公司深化产学研协同创新，联合湖州师范学院、浙江大学湖州工业控制技术研究院聚力破解工艺难题。依托 ERP+MES 数字化管理平台，实现研发、生产、测试全链条数据可追溯，产品良率稳定达到 99.99%。市场拓展上，持续深化与江波龙、得一微、德明利等存量客户的务实合作，稳步开拓紫光集团、联芸科技等优质合作资源，不断筑牢企业市场发展根基。",
      "b5": "下一步，新甚科技将坚守存储芯片为主业，抓实关键工艺技术迭代，加快科研成果产业化转化，项目达产后力争实现年新增销售额 3000 万元。切实履行国企责任担当，不断提升国产存储芯片配套测试能力，为国内半导体产业链供应链稳定可控贡献企业力量。"
    },
    "efficiency": {
      "title": "从“机械等待”到“芯片极速”：一篇看懂 SSD 如何重塑你的工作效率",
      "desc": "每天开工前漫长的开机等待，处理大文件时进度条的“沉思”，多任务切换时电脑的“凝固”瞬间……这些看似微小的卡顿，实则在持续消耗团队最宝贵的资产：时间与专注力。"
    },
    "spb4832": {
      "title": "顺序读取7300MB/s！新甚SPB4832「荣耀黄金」SSD发布，百万IOPS引爆极速体验",
      "desc": "新甚 PCIe 4.0 SSD · SPB4832 荣耀黄金 —— 天下武功，唯快不破。支持 PCIe 4.0 ×4，顺序读取 7300MB/s、随机读取 1000K IOPS。"
    }
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh.js